import { notImplementedWarn } from "./Utils";
var Service = /** @class */ (function () {
    function Service() {
    }
    // JSLL Qos is manually called by JSLL customer they add their jquery calls in service and we execute the method for them, we cannot just enable automatic tracking in 1DS because all xhr request will be tracked
    Service.prototype.get = function (requestOptions) {
        // NO OP
        notImplementedWarn("get");
    };
    Service.prototype.post = function (requestOptions) {
        // NO OP
        notImplementedWarn("post");
    };
    Service.prototype.put = function (requestOptions) {
        // NO OP
        notImplementedWarn("put");
    };
    Service.prototype.delete = function (requestOptions) {
        // NO OP
        notImplementedWarn("delete");
    };
    Service.prototype.patch = function (requestOptions) {
        // NO OP
        notImplementedWarn("patch");
    };
    Service.prototype.alwaysAddCvToRequestHeader = function () {
        // NO OP
        notImplementedWarn("alwaysAddCvToRequestHeader");
        return true;
    };
    Service.prototype.doNotChangeSupportCors = function () {
        // NO OP
        notImplementedWarn("doNotChangeSupportCors");
        return true;
    };
    Service.prototype.setTargetUriOverride = function (targetUriOverrideStringOrCallback) {
        // NO OP
        notImplementedWarn("setTargetUriOverride");
    };
    return Service;
}());
export { Service };
//# sourceMappingURL=Service.js.map